import { render, staticRenderFns } from "./AppSideMenu.vue?vue&type=template&id=671da0b0&"
import script from "./AppSideMenu.vue?vue&type=script&lang=js&"
export * from "./AppSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports